// import { SKIN_INTERFACE, unLockOneSkinById } from "../../Config/SkinConfig";
import O1HD from "../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SkinRewardPage extends cc.Component {

    @property({type:cc.Node})
    content:cc.Node = null;

    @property({type:cc.Node,displayName:"皮肤节点"})
    skinNode:cc.Node = null;

    @property({type:cc.Label,displayName:"皮肤名字文本"})
    lb_name:cc.Label = null;

    @property({type:cc.Node,displayName:"背景圈"})
    BGcircle:cc.Node = null;

    confirmFun:()=>void = null;

    start(){
        let tween = cc.tween(this.BGcircle).by(3,{angle:360});
        cc.tween(this.BGcircle).repeatForever(tween).start();
        this.open();
    }

    // data:SKIN_INTERFACE = null;

    // setData(data:SKIN_INTERFACE,confirmFun?:()=>void){
    //     this.data = data;
    //     unLockOneSkinById(data.id);
    //     this.confirmFun = confirmFun;
    //     this.updatePage();
    // }

    // updatePage(){
    //     if(!this.data) return;
    //     this.lb_name.string = this.data.name;
    //     this.loadSp();
    // }

    // loadSp(){
    //     //加载图片或者加载动画
    //     if(!this.data) return;
    //     O1HD.getModules().uiControlModule.getGameBundle().load(`Image/SkinSp/${this.data.spPath}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
    //         if(err){
    //             console.log("加载图片出错");
    //             return;
    //         }
    //         this.skinNode.getComponent(cc.Sprite).spriteFrame = asset;
    //     });
    // }

    open(){
        this.node.opacity = 0;
        cc.tween(this.node).to(0.25,{opacity:255}).start();
            cc.tween(this.content).delay(0.2).call(()=>{
                // O1HD.getManagers().soundMgr.playSound("tanchuang");
                
        }).to(0.3,{scale:1},{easing:'backOut'}).start();
    }

    close(){
        if(this.node.isValid){
            cc.tween(this.node).to(0.1,{opacity:0}).call(()=>{
                this.node.destroy();
                this.node.removeFromParent();
            }).start();
        }
    }

    onBtnConfirm(){
        this.confirmFun && this.confirmFun();
        this.close();
    }

}
